import React, { useEffect } from "react";

import { useGetWorkOrderRouting } from "../../hooks";
import { HubHookFormSelect } from "../HubHookFormSelect";

import RoutingRenderElement from "./RoutingRenderElement";
import { useFormContext } from "react-hook-form";

export const WorkOrderRoutingSelect = ({
  workOrder = "",
  name = "routingId",
  label = "Work Order Routes",
  disabled = false,
  includeSubRoutes = false,
  hideLabel,
  routeId,
  showScrollbar = false,
  ...rest
}) => {
  const { data, isLoading } = useGetWorkOrderRouting(workOrder);
  const defaultValue = routeId || data?.selected;
  const options = data?.options || [];
  const filtered = includeSubRoutes
    ? options
    : options.filter((o) => !o.isSubRoute);
  const isDisabled = isLoading || disabled || !filtered?.length;

  const { setValue } = useFormContext();

  useEffect(() => {
    const defaultValue = routeId || data?.selected;
    setValue(name, defaultValue);
  }, [data, routeId]);

  return (
    <HubHookFormSelect
      name={name}
      options={filtered}
      defaultValue={defaultValue}
      groupByKey="status"
      defaultOpenGroup="Open"
      RenderComponent={RoutingRenderElement}
      renderValue={(value) => {
        const op = filtered?.find((o) => o.id === value);
        return <RoutingRenderElement {...op} />;
      }}
      disabled={isDisabled}
      required
      showScrollbar={showScrollbar}
      {...(!hideLabel ? { label } : {})}
      {...rest}
    />
  );
};

export default WorkOrderRoutingSelect;
